import { filter, fromPairs, isEmpty, map } from 'lodash';
import Q from 'q';

import { getWidgetSessionProviderByIdAndCourseId } from 'bundles/author-common/utils/AuthoringWidgetSessionAPIUtils';
import { getAuthoringWidgetSummary } from 'bundles/widget-admin/utils/WidgetAdminAPIUtils';

export const isAssetSelected = (selectedWidgets: $TSFixMe, widget: $TSFixMe) => {
  return !isEmpty(filter(selectedWidgets, { id: widget.id }));
};

export const createWidgetMap = (widgets: $TSFixMe) => {
  return fromPairs(map(widgets, (widget: any) => [widget.id, widget]));
};

// a widget session provider is a "usage spot" for a widget. it's where a widget is used in a course
export const getWidgetQuestionProvider = ({
  widgetQuestionProviderId,
  questionId,
  courseId,
}: {
  widgetQuestionProviderId: $TSFixMe;
  questionId: $TSFixMe;
  courseId: string;
}) => {
  return Q(
    getWidgetSessionProviderByIdAndCourseId({
      id: widgetQuestionProviderId,
      courseId,
    }).then((response) => {
      const widgetProvider = response.elements[0];
      const widgetSessionProviderId = widgetProvider.id;
      const widgetDraft = widgetProvider.draft;
      const widgetDraftSummary = response.linked['authoringWidgetSummaries.v1'][0];
      const { isPublished, metadata, owners } = widgetProvider;
      return {
        widgetDraft,
        widgetDraftSummary,
        widgetSessionProviderId,
        questionId,
        isPublished,
        metadata,
        owners,
      };
    })
  );
};

// an authoring widget summary is an aggregate of information about a widget, combining info from a few sources like the authoringWidget, instances (ie where that widget is used), and permissioning (viewScope) which determines if it's soft deleted.
export const getAuthoringWidgetSummaryListByCourse = (
  courseId: string,
  filterHidden: boolean,
  filterGraded: boolean,
  filterUngraded: boolean,
  filterPublished: boolean
) => {
  const showWidget = () => true;
  const matchesHiddenFilter = filterHidden ? ({ isHidden }: $TSFixMe) => !isHidden : showWidget;
  const matchesGradedFilter = filterGraded ? ({ isGraded }: $TSFixMe) => isGraded : showWidget;
  const matchesUngradedFilter = filterUngraded ? ({ isGraded }: $TSFixMe) => !isGraded : showWidget;
  const matchesPublishedFilter = filterPublished ? ({ isPublished }: $TSFixMe) => isPublished : showWidget;

  return Q(
    getAuthoringWidgetSummary(courseId).then((response: $TSFixMe) => {
      const widgetList = filter(response.elements, (widget) => {
        return (
          matchesHiddenFilter(widget) &&
          matchesGradedFilter(widget) &&
          matchesUngradedFilter(widget) &&
          matchesPublishedFilter(widget)
        );
      });

      return widgetList;
    })
  );
};
